import * as Yup from 'yup';

export const SignUpValidationSchema = Yup.object({
  email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
  name: Yup.string().max(255).required('Name is required'),
  password: Yup.string().max(255).required('Password is required'),
  confirm_password: Yup.string().max(255).required('Confirm password is required'),
});

export const SignInValidationSchema = Yup.object({
  email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
  password: Yup.string().max(255).required('Password is required'),
});

export const ChangePasswordValidationSchema = Yup.object({
  password: Yup.string().max(255).required('Password is required'),
  confirmPassword: Yup.string().max(255).required('Confirm password is required'),
});

export const ForgotPasswordValidationSchema = Yup.object({
  email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
});
